<template>
  <section>
    <NonLogin />
    <OrderProgress
      ref="progress"
      v-model="progressPamars"
      :progressConfig="progressConfig"
      :checkNextStep="true"
      :cancelBtnHide="cancelBtnHide"
      subBtnName="完成"
      @nextStep="nextStep"
    />
    <section class="register-content-box" v-show="progressPamars.step === 1">
      <EnterpriseForm ref="enterpriseForm" />
    </section>
    <section class="register-content-box" v-show="progressPamars.step === 2">
      <LegalPersonForm ref="legalPersonForm" />
    </section>
    <section class="register-content-box" v-show="progressPamars.step === 3">
      <ScaleForm ref="scaleForm" />
    </section>
    <section class="register-content-box" v-show="progressPamars.step === 4">
      <SuccessPage finishText="注册完成" successText="感谢您选择，您的申请正在审核中，请耐心等待。我们将通过短信通知审核结果。" />
    </section>
  </section>
</template>

<script>
import { saveTenantRegister } from 'api';
import OrderProgress from 'components/progress/progress';
import SuccessPage from 'components/successPage/successPage';
import NonLogin from 'components/nonlogin/nonlogin';
import EnterpriseForm from './enterprise';
import LegalPersonForm from './legalPerson';
import ScaleForm from './scale';
import pageDataMixin from '@qx/mixin/pageData';
const IMG_ENTERPRISE = require('../../assets/images/register/enterprise.png');
const IMG_ENTERPRISE_ACTIVE = require('../../assets/images/register/enterpriseActive.png');
const IMG_LEGALPERSON = require('../../assets/images/register/legalperson.png');
const IMG_LEGALPERSON_ACTIVE = require('../../assets/images/register/legalpersonActive.png');
const IMG_SCALE = require('../../assets/images/register/scale.png');
const IMG_SCALE_ACTIVE = require('../../assets/images/register/scaleActive.png');
const IMG_SUCCESS = require('../../assets/images/register/success.png');
const IMG_SUCCESS_ACTIVE = require('../../assets/images/register/successActive.png');
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    NonLogin,
    OrderProgress,
    SuccessPage,

    EnterpriseForm,
    LegalPersonForm,
    ScaleForm,
  },
  data () {
    return {
      cancelBtnHide: false,
      progressPamars: {
        step: 1,
      },
      progressConfig: [
        {
          label: '企业信息',
          normalImgUrl: IMG_ENTERPRISE,
          activeImgUrl: IMG_ENTERPRISE_ACTIVE,
        },
        {
          label: '法人信息',
          normalImgUrl: IMG_LEGALPERSON,
          activeImgUrl: IMG_LEGALPERSON_ACTIVE,
        },
        {
          label: '企业规模',
          normalImgUrl: IMG_SCALE,
          activeImgUrl: IMG_SCALE_ACTIVE,
        },
        {
          label: '注册完成',
          normalImgUrl: IMG_SUCCESS,
          activeImgUrl: IMG_SUCCESS_ACTIVE,
        },
      ],
      formComponents: [
        'enterpriseForm',
        'legalPersonForm',
        'scaleForm',
      ],
      editParams: {
      },
    };
  },
  methods: {
    editApi: saveTenantRegister,
    // 前往下一步
    async nextStep (step) {
      let isGoNextStep = true;
      switch (step) {
        case 1:
          isGoNextStep = await this.checkComponetsSub([
            'enterpriseForm',
          ]);
          if (isGoNextStep) {
            this.$refs.progress.toNextStep();
          }
          break;
        case 2:
          isGoNextStep = await this.checkComponetsSub([
            'legalPersonForm',
          ]);
          if (isGoNextStep) {
            this.$refs.progress.toNextStep();
          }
          break;
        case 3:
          isGoNextStep = await this.checkComponetsSub([
            'scaleForm',
          ]);
          if (isGoNextStep) {
            await this.sub();
          }
          break;
        case 4:
          this.$router.push({ path: '/login' });
          break;
        default:
          break;
      }
    },
    // 提交成功之后跳转到最后一步
    handleSubSucc (res) {
      if (res === 'Y') {
        this.$refs.progress.toNextStep();
        this.cancelBtnHide = true;
      }
    },
    // 检测每个步骤
    async checkComponetsSub (componentListName) {
      let isGoNextStep = true;
      for (let i = 0; i < componentListName.length; i++) {
        const formData = await this.$refs[componentListName[i]].sub();
        // 如果有不通过验证的，formData 会返回 null，以此来判断是否可以前往下一步
        if (!formData) {
          isGoNextStep = false;
          break;
        }
      }
      return isGoNextStep;
    },
  },
};
</script>

<style lang="scss" scoped>
.getCodeBtn {
  padding-right: 8px;
}
.register-content-box {
  margin: 0 auto;
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
}
</style>
